import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './Showcase.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDog, faPaw, faCat } from '@fortawesome/free-solid-svg-icons';

function Showcase() {
  const dogImgUrl = process.env.REACT_APP_WP_SERVER + '/wp-content/uploads/2025/01/dog2fc.png';

  const quoteSliderSettings = {
    dots: true, // Enable navigation dots
    infinite: true, // Loop slides
    speed: 500, // Transition speed
    slidesToShow: 1, // Only one quote at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // Change quote every 5 seconds
    arrows: false, // Hide arrows (optional)
    fade: true, // Smooth fade transition between quotes
  };

  const [showcaseLeftContent, setShowcaseLeftContent] = useState(''); // State to hold the fetched content
  const [showcaseQuotes, setShowcaseQuotes] = useState([]); // State to hold the fetched quotes
  const [showcaseServices, setShowcaseServices] = useState([]); // State to hold the fetched services

  useEffect(() => {
    // Fetch content for showcase left
    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/intro')
      .then(response => response.json())
      .then(data => {
        if (data[0]?.content?.rendered) {
          setShowcaseLeftContent(data[0].content.rendered);
          // setShowcaseLeftContent("<h3>Your pets new best friend</h3><p>We finished our first sensor sweep of the neutral zone, and if you drop that data on the floor one more time, you’ll be flying a cargo freighter. You enjoyed that, and you know it. Fear is the true enemy, and the only thing standing between us and them. The odds are, the situation will get worse before it gets better, but I’d say that makes it interesting.</p>");
        }
      })
      .catch(error => console.error('Error fetching showcase left content:', error));

    // Fetch content for showcase quotes
    fetch(process.env.REACT_APP_WP_SERVER + "/wp-json/wp/v2/quote")
      .then((response) => response.json())
      .then((data) => {
        const modifiedQuotes = data.map((quote) => ({
          id: quote.id,
          text: quote.content.rendered.trim(), // Ensure cleaned quote text
        }));
        setShowcaseQuotes(modifiedQuotes);
      })
      .catch((error) =>
        console.error("Error fetching showcase quote content:", error));

    // Fetch content for showcase services
    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/service')
      .then(response => response.json())
      .then(data => {
        const formattedData = data.map(item => ({
          title: item.title?.rendered || '',
          content: item.content?.rendered || '',
          price: "$" + item.price || '',
        }));
        setShowcaseServices(formattedData);
      })
      .catch(error => console.error('Error fetching showcase quote content:', error));
  }, []); // Empty dependency array ensures this runs only once

  return (
    <div id={styles["showcase"]}>
      <div id={styles["intro"]} className={styles['showcase-section']}>
        {/* Showcase Left Content */}
        <div class={styles["intro-txt"]}>
          <img src={dogImgUrl} alt="Dog" />
          <div dangerouslySetInnerHTML={{ __html: showcaseLeftContent }}></div>
        </div>

        {/* Showcase Quotes */}
        <div id={styles["quote-slider"]} className={styles["block-style"]}>
          {showcaseQuotes.length > 0 && (
            <Slider {...quoteSliderSettings}>
              {showcaseQuotes.map((quote) => (
                <div key={quote.id} className={styles["quote-item"]}>
                  <p dangerouslySetInnerHTML={{ __html: quote.text }} />
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>

      <div className={styles['sep']}><FontAwesomeIcon icon={faDog} /> <FontAwesomeIcon icon={faPaw} /> <FontAwesomeIcon icon={faCat} /></div>

      <div 
        id="services"
        className={styles['services']}>
          {showcaseServices.map((service) => (
            <div key={service.id} className={styles['service-card']}>
              <div>
                <h3 dangerouslySetInnerHTML={{ __html: service.title }}></h3>
                <p dangerouslySetInnerHTML={{ __html: service.content }}></p>
                <div className={styles['service-price']} dangerouslySetInnerHTML={{ __html: service.price }}></div>
                <div className={styles['schedule-button']}>Schedule Now</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Showcase;
